export default __webpack_public_path__ + "static/vivawest-506b254049ed3962e6ccb3b7e35b50d8.jpg";